import { IApplicationState } from '../../types/redux';

export function selectActiveStep(state: IApplicationState) {
  return state.consultationRequest.activeStep;
}
